// extracted by mini-css-extract-plugin
export default {"content":"Header_content__WV-tF","contentFixed":"Header_contentFixed__wIqxX"};